import { render } from "./PermissionsField.vue?vue&type=template&id=45d37b9e"
import script from "./PermissionsField.vue?vue&type=script&lang=js"
export * from "./PermissionsField.vue?vue&type=script&lang=js"

import "./PermissionsField.vue?vue&type=style&index=0&id=45d37b9e&lang=css"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PermissionsField.vue"]])

export default __exports__